// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__NHy9F","right":"styles_right__2ZYu8"};